<template>
  <div class="xcard">
    <h3 class="text-center text-primary" style="margin-top: 0">
      Personas, Docentes y Estudiantes registrados en el Sistema.
    </h3>
    <!-- <p class="text-center"> Busque Por nombre o Numero de Documento. </p> -->
    <div class="row">
      <div class="col-sm-8">
        <div class="input-group input-group-sm">
          <div class="input-group-addon">Buscar</div>
          <input type="text" v-model="filtro" class="form-control" placeholder="Ingrese el documento o el nombre" />
        </div>
        <p class="text-primary">
          <small>{{ msg }}</small>
        </p>
      </div>
      <div class="col-sm-4 text-right">
        <v-btn small class="green white--text" @click="$router.push('/personasbyrol')"> Filtrar por rol </v-btn>
      </div>

      <p class="text-right" v-if="!$store.state.isonlyread && $store.state.CARGO.id != 13">
        <button
          :disabled="!$store.state.createProfesion"
          type="button"
          data-toggle="modal"
          data-target="#modal-nprofesion"
          title="Crear profesion"
          class="btn btn-sm btn-link">
          <span class="glyphicon glyphicon-plus"></span> Nueva Profesion
        </button>
        <button
          :disabled="!$store.state.createEmpresa"
          type="button"
          data-toggle="modal"
          data-target="#modal-nempresa"
          title="Crear empresa"
          class="btn btn-sm btn-link">
          <span class="glyphicon glyphicon-plus"></span> Nueva Empresa
        </button>
        <button
          :disabled="!$store.state.createGrado"
          type="button"
          data-toggle="modal"
          data-target="#modal-ngrado"
          title="Crear Grado"
          class="btn btn-sm btn-link">
          <span class="glyphicon glyphicon-plus"></span> Nuevo Grado
        </button>
        <button
          :disabled="!$store.state.createCiudad"
          type="button"
          data-toggle="modal"
          data-target="#modal-nciudad"
          title="Crear Ciudad"
          class="btn btn-sm btn-link">
          <span class="glyphicon glyphicon-plus"></span> Nueva Ciudad
        </button>
        <router-link to="docentesadd" class="btn btn-sm btn-link">
          <span class="glyphicon glyphicon-plus"></span> Reg. Docente</router-link
        >
        <router-link to="addPeople" class="btn btn-sm btn-link">
          <span class="glyphicon glyphicon-plus"></span> Reg. Persona</router-link
        >
      </p>

      <p v-if="isCASasesor">
        <router-link to="addPeople" class="btn btn-sm btn-link">
          <span class="glyphicon glyphicon-plus"></span> Reg. Persona</router-link
        >
      </p>
    </div>

    <p v-show="datos.length > 0">
      Presione <a class="btn btn-sm btn-link" @click="verMas()">AQUI</a> para buscar las siguientes 5 coincidencias.
    </p>
    <div class="table-responsive">
      <table class="table table-condensed table-hover table-striped">
        <thead style="background: #196391">
          <tr class="white--text">
            <th><small>Nro</small></th>
            <th><small>Nombre Completo</small></th>
            <th><small>Documento</small></th>
            <th><small>Telefono</small></th>
            <th><small>Email</small></th>
            <!-- <th><small>Usuario Moodle</small></th>
            <th><small>Clave Moodle</small></th> -->
            <th><small>Estado</small></th>
            <th><small>Registro</small></th>
            <th><small>Opciones</small></th>
            <th v-if="!$store.state.isonlyread"><small>Moodle</small></th>
          </tr>
        </thead>

        <tbody>
          <tr :key="ind" v-for="(e, ind) in datos">
            <td>
              <small> {{ tam - ind }} </small>
            </td>
            <td :title="e.id">
              <small> {{ e.nombre }} </small>
            </td>
            <td>
              <small> {{ e.num_doc }} {{ getextension(e.iddepartamento) }} </small>
            </td>
            <td>
              <small>
                <a href="#" @click="whatsapp(e.telefono1)"> {{ e.telefono1 }} </a>
              </small>
            </td>
            <td>
              <small> {{ e.email }} </small>
            </td>
            <!--  <td>
              <small> {{ e.usuario_moodle }} </small>
            </td>
            <td>
              <small> {{ e.clave_moodle }} </small>
            </td> -->
            <td xclick="openmodalestado(e)" xclass="manito">
              <small> {{ e.estado ? 'Activo' : 'Inactivo' }} </small>
            </td>
            <td>
              <small> {{ parseFecha(e.fecha_reg) }} </small>
            </td>
            <!-- <td>   <small> {{ parseProfesiones(e.profesiones) }} </small> </td> -->
            <th>
              <button
                v-if="$store.state.CARGO.id == 1"
                type="button"
                class="btn btn-sm btn-link"
                title="Editar como Master"
                @click="editarAdmin(e)">
                <span class="glyphicon glyphicon-pencil green--text"></span>
              </button>
              <button
                v-if="!$store.state.isonlyread"
                :disabled="!$store.state.updatePersona"
                type="button"
                class="btn btn-sm btn-link"
                title="Editar como TI."
                @click="editar(e)">
                <span class="glyphicon glyphicon-pencil"></span>
              </button>
              <button
                type="button"
                class="btn btn-sm btn-link"
                title="Ver programas cursados."
                @click="getProgramasByPersona(e)">
                <span class="glyphicon glyphicon-eye-open"></span>
              </button>
              <!-- <button :disabled="permissions" type="button" class="btn btn-sm btn-link" title="Asignar Codigo Estudiante." @click="showEliminar(e)" data-toggle="modal" data-target="#modal"> <span class="glyphicon glyphicon-edit"></span> </button> -->
              <button
                v-if="!$store.state.isonlyread"
                :disabled="permissions()"
                class="btn btn-sm btn-link"
                title="Crear Usuario del Sistema"
                @click="touser(e)">
                <span class="glyphicon glyphicon-user"></span>
              </button>
            </th>
            <th vv-if="!$store.state.isonlyread">
              <button
                :disabled="permissions()"
                class="btn btn-sm btn-link"
                title="Opciones del usuario en moodle"
                @click="openmodalplataforma(e)">
                <span class="glyphicon glyphicon-cog"></span>
              </button>
            </th>
          </tr>
        </tbody>
      </table>
    </div>

    <div ref="modal" class="modal" tabindex="-1" role="dialog" id="modalcitoplataformas">
      <div class="modal-dialog" role="document"> 
        <div class="modal-content">
          <div class="modal-header mb-0 pb-2">
            <h5 class="modal-title text-center mb-0 pb-0"><b>Opciones de este usuario en Moodle</b></h5>
            <!-- <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
                </button> -->
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-sm-6">
                <div>
                  <p class="mb-0"><b>Documento: </b> {{ seleccionado.num_doc }}</p>
                  <p class="mb-0">
                    <b>Nombres: </b> <span v-if="!isedit"> {{ seleccionado.nombres }} </span>
                    <input
                      v-else
                      class="form-control form-control-sm"
                      type="text"
                      v-model.trim="seleccionado.nombres" />
                  </p>
                  <p class="mb-0">
                    <b>Apellido 1: </b> <span v-if="!isedit"> {{ seleccionado.pri_apellido }} </span>
                    <input
                      v-else
                      class="form-control form-control-sm"
                      type="text"
                      v-model.trim="seleccionado.pri_apellido" />
                  </p>
                  <p class="mb-0">
                    <b>Apellido 2: </b> <span v-if="!isedit"> {{ seleccionado.seg_apellido }} </span>
                    <input
                      v-else
                      class="form-control form-control-sm"
                      type="text"
                      v-model.trim="seleccionado.seg_apellido" />
                  </p>
                </div>
              </div>
              <div class="col-sm-6">
                <div>
                  <p class="mb-0">
                    <b>Telefono 1: </b> <span v-if="!isedit"> {{ seleccionado.telefono1 }} </span>
                    <input
                      v-else
                      class="form-control form-control-sm"
                      type="text"
                      v-model.trim="seleccionado.telefono1" />
                  </p>
                  <p class="mb-0">
                    <b>Correo: </b> <span v-if="!isedit"> {{ seleccionado.email }} </span>
                    <input v-else class="form-control form-control-sm" type="text" v-model.trim="seleccionado.email" />
                  </p>
                  <p class="mb-0">
                    <b>Usuario Moodle: </b> <span> {{ seleccionado.current_username }} </span>
                  </p>
                  <p class="mb-0" v-if="isedit">
                    <b>Nuevo usuario Moodle: </b>
                    <input
                      class="form-control form-control-sm"
                      type="text"
                      v-model.trim="seleccionado.usuario_moodle" />
                  </p>
                  <p class="mb-0">
                    <b>Clave Moodle: </b> <span v-if="!isedit"> {{ seleccionado.clave_moodle }} </span>
                    <input
                      v-else
                      class="form-control form-control-sm"
                      type="text"
                      v-model.trim="seleccionado.clave_moodle" />
                  </p>
                </div>
              </div>

              <div class="col-sm-12">
                <label> <input type="checkbox" v-model="isedit" /> editar datos </label>
                <p class="text-center text-primary mb-0">Seleccione una plataforma Moodle:</p>
                <select class="form-control" v-model="plataforma">
                  <option v-for="(p, ind) in plataformas" :key="ind" :value="p">Moodle: {{ p.nombre }}</option>
                </select>

                <p>
                  <b>Seleccionado: </b>
                  <span> {{ plataforma.nombre }} </span>
                </p>

                <p class="text-center text-danger">
                  <b>{{ msg2 }}</b>
                </p>
                <v-progress-linear indeterminate height="2" v-if="loading" />
                <!-- <div class="text-center">
                  <div style="display: inline-block" v-show="loading" class="loader"></div>
                </div> -->
              </div>
            </div>
          </div>

          <div class="modal-footer">
            <button
              v-if="!isedit"
              :disabled="permissions()"
              class="btn btn-sm btn-link"
              title="Matriculacion Usuario en el Moodle"
              @click="moodlecrearuser(seleccionado, false)">
              <span class="glyphicon glyphicon-user"></span> Crear Usuario
            </button>
            <button
              v-else-if="isedit"
              :disabled="permissions()"
              class="btn btn-sm btn-link"
              title="Matriculacion Usuario en el Moodle"
              @click="moodlecrearuser(seleccionado, true)">
              <span class="glyphicon glyphicon-pencil"></span> Actualizar Usuario
            </button>
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
          </div>
        </div>
      </div>
    </div>

    <notifications group="auth" position="bottom right" />
    <modal id="modal" v-bind:obj="seleccionado" v-on:exito="modalExito" />
    <ACrearUSerMoodle id="modalmoodleuser" v-bind:obj="seleccionadomoodle" v-on:exito="modalExito" />
    <modale id="modalmoodle" v-bind:obj="seleccionadox" v-on:exito="modalExito" />
    <div><AEstadoPersona ref="estadopersona" /></div>
    <NewP />
    <NewE />
    <NewG />
    <NewC />
  </div>
</template>

<script>
import xaxios from '@/xaxios';
import gql from 'graphql-tag';
// import { error } from '@/components/Utils.js';
import modal from '@/components/ACodigoEstudiante.vue';
import NewP from '@/components/ANewProfesion.vue';
import NewE from '@/components/ANewEmpresa.vue';
import NewG from '@/components/ANewGrado.vue';
import NewC from '@/components/ANewCiudad.vue';
import modale from '@/components/AEstadoMoodle.vue';
import ACrearUSerMoodle from '@/components/ACrearUSerMoodle';
import AEstadoPersona from '@/components/APersonaEstado';
import { parseJsonError } from '@/components/Utils.js';

export default {
  data() {
    return {
      plataformas: [],
      plataforma: {},
      seleccionado: { xid: -1, xtitle: 'X', xbody: 'X', xsql: null },
      isLoading: false,
      isedit: false,
      loading: false,
      isCASasesor: false,
      timeoutHnd: 0,
      filtro: null,
      msg: null,
      msg2: '',
      sede: {},
      cursor: 10000000,
      tam: 0,
      datos: [],
      seleccionadox: { xid: -1, xtitle: 'X', xbody: 'X', xsql: null, sede: { correos: null } },
      seleccionadomoodle: { xid: -1, xtitle: 'X', xbody: 'X', xsql: null, estudiante: {}, update: false },
    };
  },
  watch: {
    filtro: function () {
      if (this.timeoutHnd) {
        clearTimeout(this.timeoutHnd);
        this.timeoutHnd = 0;
      }
      var vue = this;
      this.timeoutHnd = setTimeout(function () {
        vue.cursor = 10000000;
        if (vue.filtro.length > 2) {
          vue.asyncFind(false);
        } else {
          vue.msg = '';
          vue.datos = [];
        }
        this.timeoutHnd = 0;
      }, 500);
    },
  },
  components: { modal, NewP, NewE, NewG, NewC, modale, ACrearUSerMoodle, AEstadoPersona },
  methods: {
    permissions() {
      return this.$store.state.CARGO.id != 1 && this.$store.state.CARGO.id != 8 && this.$store.state.CARGO.id != 5;
    },
    parseLabel(option) {
      if (option == null) return '';
      var seg = option.seg_apellido;
      if (seg == null) seg = '';
      return option.nombres + ' ' + option.pri_apellido + ' ' + seg;
    },
    showEliminar(est) {
      var obj = est;
      var msg = 'Asignar Codigo Estudiante';
      var body = 'Ingrese el codigo del estudiante, este codigo se usa en la opcion de ver notas.';
      this.seleccionado = { xid: obj.id, xtitle: msg, xbody: body, xsql: '' };
    },
    getextension(iddepa) {
      if (iddepa == 1) return 'Tj';
      if (iddepa == 2) return 'Ch';
      if (iddepa == 3) return 'Pt';
      if (iddepa == 4) return 'Sc';
      if (iddepa == 5) return 'Be';
      if (iddepa == 6) return 'Pa';
      if (iddepa == 7) return 'Lp';
      if (iddepa == 8) return 'Or';
      if (iddepa == 9) return 'Cb';
      if (iddepa == 10) return 'Ext';
      return '';
    },
    modalExito() {},
    parseFecha(f) {
      if (f == null) return '';
      var date = new Date(f);
      var d = date.getDate();
      var m = date.getMonth() + 1;
      var min = date.getMinutes();
      if (d < 10) d = '0' + d;
      if (m < 10) m = '0' + m;
      if (min < 10) min = '0' + min;

      return d + '/' + m + '/' + date.getFullYear();
    },
    parseProfesiones(ps) {
      if (ps == null) return '';
      var pss = '';
      ps.forEach(function (e) {
        pss += e.nombre + ',\n';
      });
      pss = pss.trim();
      if (pss.length > 0) pss = pss.substring(0, pss.length - 1);
      return pss;
    },
    editarAdmin(est) {
      window.sessionStorage.setItem('xestudiante', JSON.stringify(est));
      window.sessionStorage.setItem('xxatrs', 'personas');
      this.$router.push({ name: 'estudiantesmod' });
    },
    editar(est) {
      // this.$notify(error('En Desarrollo', '....'));
      window.sessionStorage.setItem('xestudiante', JSON.stringify(est));
      window.sessionStorage.setItem('xxatrs', 'personas');

      const fake = 't=khdudhbx87687d&carga=jhkkjfhjghfgfhgrrrrr';
      const fakr = 'suc=eekhdudsdddhbx87687d&data=eyjhkdkjfhjghpfgfhgrrrdfrr';
      this.$router.push(`editperson?${fake}&id=${est.id}&${fakr}`);
    },
    getProgramasByPersona(est) {
      window.sessionStorage.setItem('xestudiante', JSON.stringify(est));
      this.$router.push({ name: 'programasperson' });
    },
    touser(est) {
      window.sessionStorage.setItem('xestudiante', JSON.stringify(est));
      window.sessionStorage.setItem('xxusuario', JSON.stringify(est));
      this.$router.push({ name: 'touser' });
    },
    setTipo(t) {
      if (this.filtro == null) this.filtro = '';
      this.datos = [];
      this.cursor = 10000000;
      this.tipo = t;
      this.asyncFind(false);
    },
    openmodalestado(e) {
      this.$refs.estadopersona.openmodal(e);
    },
    verMas() {
      this.asyncFind(true);
    },
    whatsapp(tel) {
      window.open(`${process.env.VUE_APP_API_WHATSAPP}591` + tel + '&text=Hola');
    },
    async asyncFind(withCursor) {
      var query = this.filtro;
      if (query && query.length > 3) {
        this.isLoading = true;
        this.msg = 'Buscando por nombre...';
        var vue = this;
        // UPD: en una consulta busca por nombres y por documento
        // let isdocumento = /^\d+$/.test(+query);
        let sql = gql`query{ 
          getPersonasByName(nombres:"${query}", ,cursor:${this.cursor}){id,estado,num_doc,iddepartamento, nombres,pri_apellido,seg_apellido,domicilio,telefono1,telefono2,email,usuario_moodle,clave_moodle,fecha_reg,profesiones{nombre},usuario{datos_personales{nombres,pri_apellido}} }
          getPersonasByDoc(num_doc:"${query}", ,cursor:${this.cursor}, estado:true){id,estado,num_doc,iddepartamento,nombres,pri_apellido,seg_apellido,domicilio,telefono1,telefono2,email,usuario_moodle,clave_moodle,fecha_reg,profesiones{nombre},usuario{datos_personales{nombres,pri_apellido}} } 
        }
        `;
        /* if (isdocumento || query.includes('-')) {
          sql = gql`query{ getPersonasByDoc(num_doc:"${query}", ,cursor:${this.cursor}, estado:true){id,estado,num_doc,iddepartamento,nombres,pri_apellido,seg_apellido,domicilio,telefono1,telefono2,email,usuario_moodle,clave_moodle,fecha_reg,profesiones{nombre},usuario{datos_personales{nombres,pri_apellido}} } }`;
          this.msg = 'Buscando por documento...';
        } */
        //window.console.log(sql);
        // this.$apollo
        //   .query({ query: sql })
        //   .then(({ data }) => (this.teachers = data && data.getPersonasByName ? data.getPersonasByName : data.getPersonasByDoc));

        await this.$apollo
          .query({ query: sql })
          .then((data) => {
            if (!withCursor) vue.datos = [];
            var datas = [];
            vue.isLoading = false;
            if (data.data == null) data.data = [];
            window.console.log('data.data',data.data)

            for (var propName in data.data) {
              if (propName == 'getPersonasByName' || propName == 'getPersonasByDoc') {
                // window.console.log( "Haber esto",data.data[propName] )
                if (!data.data[propName]) data.data[propName] = [];
                data.data[propName].forEach(function (e) {
                  e.nombre = vue.parseLabel(e);
                  datas.push(e);
                  vue.cursor = e.id;
                });
              }
            }

            if (withCursor) vue.datos = datas.concat(vue.datos);
            else vue.datos = datas;
            vue.tam = vue.datos.length;
            vue.msg = '';
            window.sessionStorage.setItem('xcursor', vue.cursor);
            window.sessionStorage.setItem('xfiltro', query);
            window.sessionStorage.setItem('xtipo', vue.tipo ? '1' : '0');
          })
          .catch((error) => {
            window.console.error(error);
            vue.isLoading = false;
            vue.msg = 'No se pudo buscar, ingrese un nombre o documento con formato valido.';
            //this.$notify( parseJsonError( error,'getEstudiantesByName' ) )
          });
      }
    },

    getCorreos(idsede) {
      var sql = gql`query{ getSede(id:${idsede}){id,nombre,correos{tipo direccion}} }`;
      this.$apollo
        .query({
          query: sql,
        })
        .then((data) => {
          this.sede = data.data.getSede;
        })
        .catch((error) => {
          this.msg = error;
          window.console.error(error);
          this.$notify(parseJsonError(error, 'getSede'));
        });
    },
    cambiarEstado(estudiante) {
      var nestado = !estudiante.estado;
      this.seleccionadox.xtitle = 'Cambiar Estado';
      this.seleccionadox.xbody = `<b>Estudiante:</b> ${estudiante.nombres} ${estudiante.pri_apellido}.<br> <b>Moodle:</b> ${estudiante.usuario_moodle}.<br><b>Nuevo Estado:</b> ${nestado}`;
      this.seleccionadox.xusername = estudiante.usuario_moodle;
      this.seleccionadox.xid = estudiante.id;
      this.seleccionadox.xestado = nestado;
      this.seleccionadox.sede = this.sede;
    },
    registrarMoodle(estudiante, update) {
      this.seleccionadomoodle.xid = estudiante.id;
      this.seleccionadomoodle.estudiante = estudiante;
      this.seleccionadomoodle.sede = this.sede;
      this.seleccionadomoodle.update = update;
    },

    openmodalplataforma(e) {
      e.current_username = e.usuario_moodle;
      this.seleccionado = window.Object.assign({}, e);
      this.msg2 = '';
      window.$('#modalcitoplataformas').modal('show');
    },

    moodlecrearuser(p, update) {
      this.msg2 = '';
      window.console.log(p);
        const rid = this.$store.state.CARGO.id
        if(rid != 8 && rid != 1) {
          this.msg2 = 'no tiene permiso pa esta accion.';
          return;
        }

      if (!this.plataforma.direccion) {
        this.msg2 = 'Seleccione una plataforma antes de continuar.';
        return;
      } 

      this.loading = true;
      let apellidos = p.pri_apellido;
      if (p.seg_apellido) apellidos += ' ' + p.seg_apellido;
      let userdata = {
        current_username: p.current_username,
        username: p.usuario_moodle,
        password: p.clave_moodle,
        firstname: p.nombres,
        lastname: apellidos,
        email: p.email,
        phone1: p.telefono1,
      };
      let data = JSON.stringify(userdata);
      // const vue = this;
      let url = `${process.env.VUE_APP_URL_API_ADAPTER_MOODLE_SERVICE.replace(/\/$/, '')}/plataformas/${
        this.plataforma.id
      }/user`;

      let headers = { 'Content-Type': 'application/json' };
      let metodo = 'post';
      if (update) metodo = 'put';
      let config = { method: metodo, url: url, headers: headers, data: data };

      window.console.log(data, config);
      xaxios.request(config)
        .then((res) => {
          window.console.log('RESPUESTA MOODLE: ', res);
          if (res.data.result) this.msg2 = res.data.result;
          this.loading = false;
        })
        .catch((error) => {
          window.console.error(error);
          this.msg2 = error;
          this.msg2 += ' (puede que el usuario ya exista).';
          this.loading = false;
        });
    },
    getDatosPlataformas() {
      this.$apollo
        .query({
          query: gql`
            query {
              getPlataformas {
                id
                nombre
                direccion
              }
            }
          `,
        })
        .then(({ data: { getPlataformas } }) => {
          this.plataformas = getPlataformas;
          this.plataformas.push({ id: -1, nombre: 'DE PRUEBAS', direccion: 'https://moodleservicedev.esam.edu.bo' });
        })
        .catch((err) => {
          this.$root.$notify.show(`ERROR: getPlataformas(ViewProgramaModules) ${err}`);
        });
    },
  },
  mounted() {
    var c = sessionStorage.xcursor;
    var f = sessionStorage.xfiltro;
    var t = sessionStorage.xtipo;
    this.isCASasesor = this.$store.state.CARGO.id == 13 && this.$store.state.CARGO.idsede == 17;

    if (c) {
      this.cursor = c;
      this.filtro = f;
      this.tipo = t == '1' ? true : false;
    }
    this.getCorreos(this.$store.state.CARGO.idsede);
    this.getDatosPlataformas();
  },
};
</script>
